var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-60.000000, -1105.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Settings",
    transform: "translate(60.000000, 1105.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3276818,19.2865638 C15.5121736,20.0199293 13.4480514,19.1444873 12.7126557,17.3288332 C11.9793491,15.513179 12.85681,13.4468017 14.6723182,12.7134362 C16.4878264,11.9800707 18.5519486,12.8576021 19.2852551,14.6732562 C20.0185617,16.4889103 19.1411008,18.5531983 17.3276818,19.2865638 L17.3276818,19.2865638 Z M27.6838088,22.7005786 L28.9749297,19.6145934 L26.0354359,17.0467695 L26.0354359,15.0284474 L29,12.4752491 L27.729771,9.38090646 L23.8208919,9.64416586 L22.4085978,8.22966892 L22.6989956,4.31420765 L19.6132583,3.02507232 L17.0331057,5.97942784 L15.0400161,5.97942784 L12.4744877,3 L9.38039373,4.27033108 L9.64363198,8.17743491 L8.23133789,9.59193185 L4.31410205,9.29942141 L3.02298112,12.3854066 L5.96456408,14.9532305 L5.96456408,16.9736419 L3,19.5247509 L4.27022901,22.6211829 L8.14777019,22.3579235 L9.58931298,23.7995821 L9.29891523,27.6857923 L12.3867417,28.977017 L14.9376456,26.0519126 L16.9850542,26.0519126 L19.5255123,29 L22.6175171,27.7317583 L22.356368,23.8518161 L23.7979108,22.4122469 L27.6838088,22.7005786 Z",
    id: 259
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionSettings);
export default __webpack_public_path__ + "static/media/navigation-and-action-settings.75af3daa.svg";
export { ForwardRef as ReactComponent };